var map = {
	"./backoffice.de.locale.json": 74625,
	"./backoffice.el.locale.json": 29355,
	"./backoffice.en.locale.json": 59657,
	"./backoffice.es.locale.json": 42124,
	"./backoffice.fr.locale.json": 1424,
	"./backoffice.it.locale.json": 21847,
	"./backoffice.ru.locale.json": 26683,
	"./backoffice.zh.locale.json": 56326,
	"./base.de.locale.json": 6619,
	"./base.el.locale.json": 57837,
	"./base.en.locale.json": 88591,
	"./base.es.locale.json": 36250,
	"./base.fr.locale.json": 96162,
	"./base.it.locale.json": 44097,
	"./base.ru.locale.json": 33025,
	"./base.zh.locale.json": 77820,
	"./customerAnalytics.de.locale.json": 75180,
	"./customerAnalytics.el.locale.json": 34346,
	"./customerAnalytics.en.locale.json": 42152,
	"./customerAnalytics.es.locale.json": 64317,
	"./customerAnalytics.fr.locale.json": 76969,
	"./customerAnalytics.it.locale.json": 95982,
	"./customerAnalytics.ru.locale.json": 76026,
	"./customerAnalytics.zh.locale.json": 61879,
	"./giftSelection.de.locale.json": 15048,
	"./giftSelection.el.locale.json": 34950,
	"./giftSelection.en.locale.json": 99140,
	"./giftSelection.es.locale.json": 29169,
	"./giftSelection.fr.locale.json": 87645,
	"./giftSelection.it.locale.json": 78658,
	"./giftSelection.ru.locale.json": 19310,
	"./giftSelection.zh.locale.json": 41219,
	"./services.de.locale.json": 902,
	"./services.el.locale.json": 22876,
	"./services.en.locale.json": 92446,
	"./services.es.locale.json": 60443,
	"./services.fr.locale.json": 93939,
	"./services.it.locale.json": 17296,
	"./services.ru.locale.json": 32800,
	"./services.zh.locale.json": 37965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4572;